export default __webpack_public_path__ + "static/media/Mp4.cbbe4b7d.svg";